<template >
    <div style="padding: 30px;font-size: 30px; text-align: left; color: white">
        <div class="time" id="time" >
            今天是：<br>
          <span class="date">{{ nowTime }}</span>
          <br>
         <div class="time-1">
            <span class="hour" >{{time.hour}}</span>
            <a class="split">:</a>
            <span class="minitus">{{time.minitus}}</span>
            <a class="split">:</a>
            <span class="seconds">{{time.seconds}}</span>
        </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ClockPanel",
        props: ["s"],
        data() {
            return {
                time: {
                    hour: "",
                    minitus: "",
                    seconds: ""
                },
                nowTime: "",
                timer: null,
                week: [
                    "星期天",
                    "星期一",
                    "星期二",
                    "星期三",
                    "星期四",
                    "星期五",
                    "星期六"
                ]
            };
        },
        mounted() {
            this.dateTime();
        },
        beforeDestroy() {
            // 清理自递归定时器，避免组件销毁后仍每秒重渲染
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
        },
        methods: {
            dateTime() {
                this.timeFormate();
                this.timer = setTimeout(() => {
                    this.dateTime();
                }, 1000);
            },
            timeFormate() {
                const newtime = new Date();
                this.time.hour = this.getIncrease(newtime.getHours(), 2);
                this.time.minitus = this.getIncrease(newtime.getMinutes(), 2);
                this.time.seconds = this.getIncrease(newtime.getSeconds(), 2);
                this.nowTime =
                    this.getIncrease(newtime.getFullYear(), 4) +
                    "年" +
                    this.getIncrease(newtime.getMonth() + 1, 2) +
                    "月" +
                    this.getIncrease(newtime.getDate(), 2) +
                    "日 " +
                    this.week[newtime.getDay()];
                //this.hour=
               // return `${this.time.hour}:${this.time.minitus}:${this.time.seconds}`;
            },
            getIncrease(num, digit) {
                var increase = "";
                for (var i = 0; i < digit; i++) {
                    increase += "0";
                }
                return (increase + num).slice(-digit);
            }
        }
    }
</script>

<style scoped>
    .txt-data .time {
        font-size: 1rem;
        margin-right: 0.5rem;
    }
    .split {
        animation: shark 1s step-end infinite;
        vertical-align: center;
        margin-left: 2px;
        margin-right: 2px;
    }
    @keyframes shark {
        0%,
        100% {
            opacity: 1;
        }
        50% {
            opacity: 0;
        }
    }
.time-1{
  display: flex;
  justify-content: center;
  margin-top: 20px;

  //background-size: cover; /* 或使用 contain */
  //background-position: center;
  //background-repeat: no-repeat;
  font-size: 50px;
  width: 300px;
  border-radius: 20px;
  border: rgb(255, 255, 255) solid 5px;




}

</style>